export default __webpack_public_path__ + "static/media/IMG-20241210-WA0047.c5bc47df.jpg";